import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Box from "@material-ui/core/Box";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import { Grid, Select, Tooltip, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import * as moment from "moment";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import mentorshipIcon from "../../../../../assets/svg/dashboard/view-Mentroships.svg";
import mentorIcon from "../../../../../assets/svg/mentorsMiniCircle.svg";
import engagementIcon from "../../../../../assets/svg/dashboard/engagement-summary.svg";
import CohortSummaryModal from "../../../../common/cohortSummaryModal";
import { MY_MENTORS_LIST } from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

import axios from "axios";
import "./style.scss";
import { useWindowDimensions } from "../../../../common/windowsize";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const useStyles = makeStyles((theme) => ({
  fexcommon: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-between",
    height: "100px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  table: {
    [theme.breakpoints.down("md")]: {
      overflowX: "hidden",
    },
  },
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
    // whiteSpace: "nowrap",
  },

  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
   
    [theme.breakpoints.down("md")]: {
      display: "flex",
      justifyContent: "right",
      textAlign: "right",
      position: "relative",
      paddingLeft: "100px",
      fontSize: "13px",
    },
  },
  tableHeader: {
    fontSize: "14px",
    fontFamily: "Montserrat",
    color: "#212529",
    fontWeight: 600,
    padding: "7px 5px",
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      left: "16px",
      top: "16px",
      width: "170px",
      textAlign: "left",
      fontSize: "12px",
    },
  },
  root: {
    marginBottom: "30px",
    [theme.breakpoints.down("md")]: {
      overflowX: "hidden",
    },
  },
  commonWidth: {
    width: "205px",
  },
  lessWidth: {
    width: "170px",
    fontSize: "16px",
    fontFamily: "Montserrat",
    "&:hover": {
      cursor: "pointer",
    },
  },
  tooltip: {
    backgroundColor: "#816aaf",
    // backgroundColor: '#efefef'
  },
  tooltipTy: {
    color: "#fff",
    fontFamily: "Montserrat",
    fontSize: "16px",
  },
  number: {
    [theme.breakpoints.down("md")]: {
      marginTop: "40px",
      borderTop: "1px solid rgba(0,0,0,0.4)",
    },
  },
}));

export default function BasicTable(props) {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const redirectProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/startup-profile/${item}`, "_blank");
    reRoute.id = item;
    // history.push({
    //   pathname: "/startup-profile",
    //   state: dpiitNo,
    //   // state: { data: props.history.location.state, prevPage: "startUpDash" },
    // });
  };
  const classes = useStyles();
  // const { data } = props;
  const [modalVisibility, setModalVisibility] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [fromModule, setFromModule] = React.useState("");
  const [cohortModalData, setCohortModalData] = React.useState("");
  // React.useEffect(() => {
  //   const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  //   props.openLoader();

  // }, []);
  const getMentorsList = (id) => {
    let params = {
      requestedBy: id,
    };
    // axios({
    //   url: MY_MENTORS_LIST,
    //   method: "POST",
    //   data: {
    //     requestedBy: id,
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 10,
    //       sortField: "name",
    //       sortOrder: "ASC",
    //     },
    //   },
    // })
    api
      .POST(MY_MENTORS_LIST, {
        requestedBy: id,
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 10,
          sortField: "name",
          sortOrder: "ASC",
        },
      })
      .then((res) => {
        setCohortModalData(res?.data?.data);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };

  const dimension = useWindowDimensions();
  const small = dimension.width < 900;

  const HeaderItem = (props) => {
    return small ? <div className={classes.tableHeader}>{props.t}</div> : "";
  };
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    return btoa(text);
  };
  return (
    <div className="messagetable-mom hello">
      <Box className={classes.root}>
        <TableContainer className={classes.root} component={Paper}>
          <Table className={classes.table} aria-label="simple table">
          {!small && props.data?.length > 0 && (
              <TableHead>
                <TableRow>
                  <TableCell
                    className={[
                      clsx(
                        classes.tableRightBorder,
                        classes.tableHeader,
                        "tableJustify fixColumbnWidth4"
                      ),
                    ]}
                    style={{width:'2%'}}
                  >
                    NO.
                  </TableCell>
                  <TableCell
                    colSpan={2}
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                    style={{width:'25%'}}
                  >
                    STARTUP
                  </TableCell>
                  <TableCell
                    colSpan={2}
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                    style={{width:'20%'}}
                  >
                    MENTOR
                  </TableCell>

                  <TableCell
                    className={[
                      clsx(
                        classes.tableRightBorder,
                        classes.tableHeader,
                        "tableJustify fixColumbnWidth4"
                      ),
                    ]}
                    style={{width:'13%'}}
                  >
                    MENTORSHIP ID
                  </TableCell>
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                    style={{width:'10%'}}
                  >
                    SESSIONS 
                  </TableCell>
                  {/* <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                    style={{width:'10%'}}
                  >
                    SESSIONS COMPLETED
                  </TableCell> */}
                  {/* <TableCell
                  className={clsx(
                    classes.tableRightBorder,
                    classes.tableHeader
                  )}
                >
                  VIEW MENTORSHIPS
                </TableCell> */}
                  <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )} 
                    style={{width:'10%'}}

                  >
                    HOURS 
                  </TableCell>
                  {/* <TableCell
                    className={clsx(
                      classes.tableRightBorder,
                      classes.tableHeader
                    )}
                    style={{width:'10%'}}
                  >
                    HOURS 
                  </TableCell> */}
                </TableRow>
              </TableHead>
            )}
            <TableBody>
              {props.data?.length > 0 ? (
                props.data?.map((datum, index) => (
                  <TableRow
                    key={index}
                    style={{
                      backgroundColor:
                        props.selectedRow == index ? "#e2d2ed" : "",
                    }}
                  >
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont, "tablefontpadding",
                        { [classes.number]: index > 0 }
                      )}
                    >
                      <HeaderItem t="NO." className />
                      {(props.currentPage - 1) * 10 + index + 1}
                    </TableCell>

                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,"tablefontpadding"
                      )}
                    >
                      <HeaderItem t="STARTUP" />
                      <div className="newuserTooltip">
                        <Link
                          style={{
                            color: "#3ac2d7",
                            textDecoration: "underline",
                          }}
                        >
                          <img
                            src={datum.startup?.logo || hashImage}
                            style={{
                              height: "100px",
                              width: "100px",
                              maxWidth: "none",
                              objectFit: "contain",
                            }}
                            onClick={() => {
                              redirectProfile(datum.startup?.dippNumber);
                            }}
                          />
                        </Link>
                        <span
                          className="tooltiptext tooltip-bottom "
                          style={{
                            left: "50px",
                            top: "88px",
                            width: "150px",
                            padding: "3px 10px",
                          }}
                        >
                          View Startup Profile
                        </span>
                      </div>
                      {/* </Tooltip> */}
                    </TableCell>
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,"tablefontpadding"
                      )}
                    >
                      <div
                        style={{
                          flexDirection: "row",
                          // display: "flex",
                          justifyContent: "space-between",
                          // height: "100px",
                          // maxWidth: "240px",
                        }}
                        className="startuporgnamedivmntrmntrship"
                      >
                        <div
                          style={{
                            cursor: "default",
                            alignItems: "center",
                            display: "flex",
                            maxWidth: "240px",
                          }}
                        >
                          {datum.startup?.organization_name}
                        </div>
                        <div className="newuserTooltip profileButton-viewprofile">
                          <div
                            className="d-flex justify-content-end profileButton-viewprofilein"
                            style={{
                              cursor: "pointer",

                              alignItems: "end",
                              justifyContent: "center",
                              // height: "100px",
                              // width: "40px",
                              display: "flex",
                            }}
                          >
                            <img
                              src={profile}
                              onClick={() => {
                                redirectProfile(datum.startup?.dippNumber);
                              }}
                            />
                          </div>
                          <span
                            className="tooltiptext2 tooltip-bottom2"
                            style={{
                              left: "-19px",
                              top: "106px",
                              width: "150px",
                              padding: "3px 10px",
                            }}
                          >
                            View Startup Profile
                          </span>
                        </div>
                      </div>
                    </TableCell>

                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,"tablefontpadding"
                      )}
                    >
                      <HeaderItem t="MENTOR" />
                      <div className="newuserTooltip ">
                        <Link
                          style={{
                            color: "#3ac2d7",
                            textDecoration: "underline",
                          }}
                        >
                          <img
                            src={datum.mentor?.image || hashImage}
                            style={{
                              height: "100px",
                              width: "100px",
                              maxWidth: "none",
                              objectFit: "contain",
                            }}
                            onClick={() => {
                              const currentRoute = window.location.href;
                              let sample;
                              sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
                              window.open(sample + `/mentor-profile/${encryptAES2(datum.mentor?.email,PROFILE_KEY)}`, "_blank");
                              // window.open(
                              //   `/mentor-profile/${datum.mentor?.email}`,
                              //   "_blank"
                              // );
                            }}
                          />
                        </Link>
                        <span
                          className="tooltiptext tooltip-bottom "
                          style={{
                            left: "50px",
                            top: "88px",
                            width: "150px",
                            padding: "3px 10px",
                          }}
                        >
                          View Mentor Profile
                        </span>
                      </div>
                      {/* </Tooltip> */}
                    </TableCell>
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,"tablefontpadding"
                      )}
                    >
                      <div
                        style={{
                          flexDirection: "row",
                          // display: "flex",
                          justifyContent: "space-between",
                          // height: "100px",
                          // maxWidth: "240px",
                        }}
                        className="startuporgnamedivmntrmntrship"
                      >
                        <div
                          style={{
                            cursor: "default",
                            alignItems: "center",
                            display: "flex",
                            maxWidth: "240px",
                          }}
                        >
                          {datum.mentor?.applicant_name}
                        </div>
                        <div className="newuserTooltip">
                          <div
                            className="d-flex justify-content-end abovemenid"
                            style={{
                              cursor: "pointer",

                              alignItems: "end",
                              justifyContent: "center",
                              // height: "100px",
                              // width: "40px",
                              display: "flex",
                            }}
                          >
                            <img
                              src={profile}
                              onClick={() => {
                                const currentRoute = window.location.href;
                              let sample;
                              sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
                              window.open(sample + `/mentor-profile/${encryptAES2(datum.mentor?.email,PROFILE_KEY)}`, "_blank");
                              }}
                            />
                          </div>
                          <span
                            className="tooltiptext2 tooltip-bottom2"
                            style={{
                              left: "-19px",
                              top: "106px",
                              width: "150px",
                              padding: "3px 10px",
                            }}
                          >
                            View Mentor Profile
                          </span>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,"tablefontpadding",
                        "menidtdmblmain"
                      )}
                      style={{ position: "relative" }}
                    >
                      <HeaderItem t="MENTORSHIP ID" />
                      <div className="newuserTooltip ">
                        <Link
                          style={{
                            color: "#3ac2d7",
                            textDecoration: "underline",
                            marginBottom: "10px",
                          }}
                          onClick={() =>
                            props.onMentorshipIdClick(
                              datum?.mentorRequest?.requestJson
                            )
                          }
                        >
                          M{datum?.id?.substr(datum?.id?.length - 6)}
                        </Link>
                        <span
                          className="tooltiptext tooltip-bottom "
                          style={{
                            width: "144px",
                            height: "50px",
                            left: "31px",
                          }}
                        >
                          View Mentorship Requirement
                        </span>
                      </div>
                      {/* <Tooltip
                        classes={{
                          tooltip: classes.tooltip,
                          tooltipArrow: classes.tooltipArrow,
                        }}
                        PopperProps={{
                          disablePortal: true,
                        }}
                        placement="bottom"
                        arrow
                        title={
                          <Typography
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              color: "#fff",
                              // fontWeight: "bold",
                            }}
                          >
                            Click to View Mentorship Engagement Summary
                          </Typography>
                        }
                      > */}
                      <div
                        className="newuserTooltip menidtdmblmaininner"
                        style={{
                          // position: "absolute",
                          right: "0px",
                          bottom: "0px",
                          padding: "12px",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={engagementIcon}
                          width={40}
                          height={40}
                          onClick={() => {
                            window.open(
                              `/startup-dashboard/mentorships/engagement-summary/${datum?.id}`,
                              "_blank"
                            );
                          }}
                        />
                        <span
                          className="tooltiptext tooltip-bottom hiddentooltip-formb"
                          style={{
                            width: "184px",
                            height: "51px",
                            top: "60px",
                            left: "35px",
                          }}
                        >
                          View Mentorship Engagement Summary
                        </span>
                      </div>
                      {/* </Tooltip> */}
                    </TableCell>
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,"tablefontpadding"
                      )}
                    >
                      <HeaderItem t="SESSIONS " />
                      Scheduled : {datum.sessionScheduled}<br></br>
                      Completed : {datum.sessionCompleted}
                    </TableCell>
                    {/* <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,"tablefontpadding"
                      )}
                    >
                      <HeaderItem t="SESSIONS COMPLETED" />
                      {datum.sessionCompleted}
                    </TableCell> */}
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,"tablefontpadding"
                      )}
                    >
                      <HeaderItem t="HOURS " />
                      Scheduled : {datum.hoursScheduled}<br></br>
                      Completed : {datum.hoursCompleted}
                    </TableCell>
                    {/* <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,"tablefontpadding"
                      )}
                    >
                      <HeaderItem t="HOURS COMPLETED" />
                      {datum.hoursCompleted}
                    </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <tr colSpan={8} style={{ border: "none" }}>
                  <td
                    className="d-flex justify-content-center"
                    style={{ border: "none" }}
                  >
                    {" "}
                    <div
                      className="no-records"
                      style={{
                        position: "relative",
                        left: "28rem",
                        whiteSpace: "nowrap",
                      }}
                    >
                      No Records Found
                    </div>
                  </td>
                </tr>
              )}
            </TableBody>
            <CohortSummaryModal
              setModalVisibility={setModalVisibility}
              fromModule={fromModule}
              modalVisibility={modalVisibility}
              modalData={cohortModalData}
              fromPage={"mentorships"}
            />
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
